'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _components = require('components');

var _utils = require('helpers/utils');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var BoxcomAuth = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    response: ownProps.location.query
  };
}), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(BoxcomAuth, _Component);

  function BoxcomAuth() {
    var _ref;

    (0, _classCallCheck3.default)(this, BoxcomAuth);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = BoxcomAuth.__proto__ || (0, _getPrototypeOf2.default)(BoxcomAuth)).call.apply(_ref, [this].concat(args)));

    _this.state = { response: {} };
    return _this;
  }

  (0, _createClass3.default)(BoxcomAuth, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _get3.default)(BoxcomAuth.prototype.__proto__ || (0, _getPrototypeOf2.default)(BoxcomAuth.prototype), 'componentDidMount', this).call(this, this.onMount);
    }
  }, {
    key: 'onMount',
    value: function onMount() {
      var response = this.props.response;

      this.setState({ response: response });
      window.opener.dispatchEvent((0, _utils.customEvent)('onBoxcomAuth', response));
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;
      var response = this.state.response;


      return _react2.default.createElement(
        'div',
        { className: 'compactContent' },
        response.error_description ? _react2.default.createElement(
          'div',
          { className: 'error' },
          response.error_description
        ) : _react2.default.createElement(
          'div',
          { className: 'text-center' },
          t('Loading...'),
          _react2.default.createElement(_components.Loader, { mask: true })
        )
      );
    }
  }]);
  return BoxcomAuth;
}(_ClientSideComponent2.default), _class3.propTypes = {
  response: _propTypes2.default.object,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onMount', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onMount'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = BoxcomAuth;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/BoxcomAuth/BoxcomAuth.js
// module id = 2145
// module chunks = 1